import { useEffect } from 'react'
import { styled } from 'styled-components'

interface Prop {
    setTitle: React.Dispatch<React.SetStateAction<string>>
}

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background-color: #ffffff;
`

const Content = styled.div`
    padding: 50px 30px;
    display: flex;
    flex-direction: column;
    gap: 50px;
`

const Hero = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
`

const HeroContent = styled.div`
    padding: 30px 50px;
    line-height: 2.6;
`

const ProfileImage = styled.img`
    width: 64px;
    height: 64px;
`

const Profile = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    gap: 30px;
    border: 1px solid #e6e6e6;
    padding: 20px;
    border-radius: 10px;
    width: 100%;
`
const ProfileGroup = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 20px;
`

const ProflieContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

const Collaborators = styled.div`
    padding-top: 30px;
    display: flex;
    justify-content: center;
    gap: 20px;
`

const Img = styled.img`
    height: 60px;
`

const HeroImage = styled.img`
    width: 50%;
    max-height: 350px;
    object-fit: cover;
    border-radius: 10px;
    flex-shrink: 0;
`

const Header = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    border-bottom: 1px solid #e5e6eb;
`

export default function AboutUs({ setTitle }: Prop) {
    useEffect(() => {
        setTitle('About Us')
    }, [])
    return (
        <Wrapper>
            <Header>
                About US | Meet the research team at Deakin University
            </Header>
            <Content>
                <div>
                    <Hero>
                        <HeroImage src="./images/about-us/hero.png" />
                        <HeroContent>
                            <h1>Move the Next Generation</h1>
                            <h3>
                                An AI automated movement skill assessment
                                solution
                            </h3>
                            <p>
                                Moving the The Gen automatically assesses and
                                reports on children's level of proficiency
                                across seven movement skills. This data will
                                allow you to plan and deliver targeted teaching
                                and learning programs based on the students’
                                movement competence, evaluate the impact of your
                                teaching, and adapt your teaching to better meet
                                the needs of all students.
                            </p>
                        </HeroContent>
                    </Hero>
                </div>
                <ProfileGroup>
                    <Profile>
                        <ProfileImage src="./images/about-us/natalie-lander.png" />
                        <ProflieContent>
                            <p>A/Professor Natalie Lander,</p>
                            <p>IPAN, Deakin Univerisity</p>
                        </ProflieContent>
                    </Profile>
                    <Profile>
                        <ProfileImage src="./images/about-us/lisa-barnett.png" />
                        <ProflieContent>
                            <p>A/Professor David Surname</p>
                            <p>IPAN, Deakin Univerisity</p>
                        </ProflieContent>
                    </Profile>
                    <Profile>
                        <ProfileImage src="./images/about-us/tao-zhou.png" />
                        <ProflieContent>
                            <p>Doctor Tao Zhou,</p>
                            <p>IISRI, Deakin Univerisity</p>
                        </ProflieContent>
                    </Profile>
                    <Profile>
                        <ProfileImage src="./images/about-us/yuxin-zhang.png" />
                        <ProflieContent>
                            <p>Doctor Yuxin Zhang,</p>
                            <p>IPAN, Deakin Univerisity</p>
                        </ProflieContent>
                    </Profile>
                </ProfileGroup>
                <div>
                    <Collaborators>
                        <Img src="./images/about-us/deakin.png" />
                        <Img src="./images/about-us/ipan.png" />
                        <Img src="./images/about-us/iisri.png" />
                        <Img src="./images/about-us/sport-and-recreation-victoria.jpg" />
                    </Collaborators>
                </div>
            </Content>
        </Wrapper>
    )
}
